import _ from 'lodash'

function getUniqueDestinationsFromLegs(legs) {
  let destinations = []
  for (let i = 0; i < legs.length; i++) {
    if (i > 0) destinations.push(legs[i].departure_airport)
    destinations.push(legs[i].arrival_airport)
  }

  if (legs.length > 1) destinations = destinations.slice(0, -1)

  return _.uniqBy(destinations, 'id')
}

export function getMunicipalitiesFromTripLegs(legs) {
  if (!legs?.length) return 'None'

  return getUniqueDestinationsFromLegs(legs)
    .map((leg) => leg.municipality)
    .join(', ')
}

export function getAirportCodesFromTripLegs(legs) {
  if (!legs?.length) return

  return getUniqueDestinationsFromLegs(legs).map((leg) => leg.display_code)
}

export function getLegDisplayName(leg) {
  return (
    leg.departure_airport.municipality +
    ' to ' +
    leg.arrival_airport.municipality
  )
}
